import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Alert,
  Box,
  CircularProgress,
  Container,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import Header from "../header_h/Header";
import Footer from "../footer/Footer";
import { getAuthorsBySubject } from "../../api/subjects";
import "../class_page/class_page.css";

const SubjectPage = ({ userName, userRoles }) => {
  const { id, subject } = useParams();

  const [authors, setAuthors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;

    async function load() {
      setLoading(true);
      setError(null);

      try {
        const data = await getAuthorsBySubject(id, subject);
        if (!alive) return;
        setAuthors(Array.isArray(data) ? data : []);
      } catch (e) {
        const status = e?.response?.status;
        const message =
          e?.response?.data?.message ||
          e?.response?.data ||
          e?.message ||
          "Помилка завантаження";
        if (alive) setError(status ? `${status}: ${message}` : String(message));
        if (alive) setAuthors([]);
      } finally {
        if (alive) setLoading(false);
      }
    }

    load();
    return () => {
      alive = false;
    };
  }, [id, subject]);

  return (
    <>
      <Header userName={userName} userRoles={userRoles} />

      <Container maxWidth="md" className="catalog-page">
        <Box className="catalog-page__heading">
          <Typography variant="h4" component="h1">
            Автори
          </Typography>
          <Typography color="text.secondary">
            Оберіть автора, щоб переглянути доступні модулі.
          </Typography>
        </Box>

        <Paper className="catalog-panel" variant="outlined">
          {loading && (
            <Box className="catalog-state">
              <CircularProgress size={28} />
              <Typography>Завантаження...</Typography>
            </Box>
          )}
          {error && <Alert severity="error">{error}</Alert>}

          {!loading && !error && (
            <List disablePadding className="catalog-list">
              {authors.length > 0 ? (
                authors.map((author) => (
                  <ListItemButton
                    key={author.id || `${author.classId}-${author.subjectSlug}-${author.authorSlug}`}
                    component={Link}
                    to={`/class/${id}/${subject}/${author.authorSlug}/modules`}
                    className="catalog-list__item"
                  >
                    <ListItemText primary={author.name} />
                    <ChevronRightRoundedIcon />
                  </ListItemButton>
                ))
              ) : (
                <Typography className="catalog-empty">Поки що немає авторів.</Typography>
              )}
            </List>
          )}
        </Paper>
      </Container>

      <Footer />
    </>
  );
};

export default SubjectPage;
